export default __webpack_public_path__ + "static/media/table-list.148474ea.svg";